<template>
  <v-container>
    <v-row>
      <v-col class="12" lg="12">
        <panel-title
          icon="mdi-code-braces"
          title="Geliştirici Araçları"
          desc="Sistem üzerindeki tümleşik yapıların yönetilebilir olan alanlarına buradan erişebilirsiniz"
        />
      </v-col>
      <v-col cols="12" lg="6" :key="nav.name" v-for="nav in navigation">
        <v-hover v-slot="{hover}">
          <v-card class="d-flex" height="200" :color="hover ? 'grey darken-3' : ''" :dark="hover">
          <RouterLink
            :to="nav.links+'/'+nav.link"
            class="dev-link-item text-decoration-none d-flex justify-space-between align-center px-3 py-3"
          >
            <h1 class="d-flex align-end text-h4">
              <v-icon class="mr-2" size="120">{{nav.icon}}</v-icon>
              <v-sheet color="transparent" class="mb-5">{{nav.name}}</v-sheet color="transparent">
            </h1>
            <v-icon size="35">mdi-open-in-new</v-icon>
          </RouterLink>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PanelTitle from "@/components/PanelTitle";
export default {
  name: "DeveloperIndex",
  components: {
    PanelTitle
  },
  data(vm) {
    return {
      navigation: vm.$store.getters.getSettingsNav("developer")
    };
  },
  mounted() {
    // this.$store.getters.getSettingsNav("developerr")
  }
};
</script>

<style>
.dev-link-item{
  width: 100%;
}
</style>